import React from "react";
import styled from "styled-components";
import { translate } from "../services/i18n";

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 10px 15px;
  margin-bottom: 15px;
  gap: 10px;

  input {
    flex: 1;
    background: transparent;
    border: none;
    border-bottom: 1px solid #888888aa;
    color: white;
    font-size: 14px;
    padding: 6px 4px;
    outline: none;
    font-family: inherit;

    &::placeholder {
      color: #aaaaaa;
    }
  }

  svg {
    color: #aaaaaa;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
`;

const SearchBar = ({ value, onChange }) => {
  return (
    <SearchWrapper>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={translate("search.placeholder", { defaultValue: "Buscar jogador..." })}
      />
      {value && (
        <button
          onClick={() => onChange("")}
          style={{
            background: "transparent",
            border: "none",
            color: "#aaaaaa",
            cursor: "pointer",
            fontSize: "18px",
            lineHeight: 1,
            padding: "0 4px",
          }}
          aria-label="Limpar busca"
        >
          ×
        </button>
      )}
    </SearchWrapper>
  );
};

export default SearchBar;
